import CrossIcon from "@assets/icons/cross.svg";
import styled from "@emotion/styled";
import { row } from "@ui/style";
import { colors } from "@ui/style/colors";
import React, { HTMLAttributes } from "react";

interface FilterTagProps extends HTMLAttributes<HTMLDivElement> {
	label: string;
	onCrossClicked: () => void;
}

export const FilterTag = ({ label, onCrossClicked }: FilterTagProps): JSX.Element => (
	<TagContainer>
		<div className="p-size-s-bold">{label}</div>
		<StyledCrossIcon height={16} width={16} onClick={onCrossClicked} />
	</TagContainer>
);

const TagContainer = styled.div`
	${row(8, "center", "center")}
	padding:8px 16px;
	border-radius: 32px;
	border: 1px solid ${colors.primary25};
	width: fit-content;
`;

const StyledCrossIcon = styled(CrossIcon)`
	cursor: pointer;
`;
